import React, { Component } from "react";
import { connect } from 'react-redux';
import { getUserProfile, saveUserProfile } from '../../actions/ProfileAction';
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ClipLoader } from 'react-spinners';
import { css } from 'emotion';
import profileImage from '../../styles/images/profile.jpg';

const override = css`
    display: block;
    margin: 0 auto;
    border-color: red;
`;

class Profile extends Component {
    constructor(props) {
        super(props);
        this.state = {
            Name: "",
            SurName: "",
            PhoneNumber: "",
            PhoneExtention: "",
            Email: "",
            Role: 0,
            controller: true,
            loading: false,
            sayac: 0,
        };
    }

    handleChange(e) {
        const { name, value } = e.target;
        if ([name] === "PhoneNumber" || [name] === "PhoneExtension") {
            if (value.length < 14 && (value === null || value.slice(-1) <= 9)) {
                this.setState({ [name]: value });
            }
        }
        else
            this.setState({ [name]: value });
    }

    componentDidMount() {
        this.props.getUserProfile();
    }

    componentDidUpdate() {
        if (this.props.userDetail != null && this.state.controller) {
            var user = this.props.userDetail;
            this.setState({ Name: user.firstName, SurName: user.lastName, PhoneNumber: user.phoneNumber, PhoneExtention: user.phoneExtention, Email: user.email, controller: false, Role: user.contactTypeId });
        }
    }

    saveUserProfile() {
        this.setState({ loading: true });
        this.props.saveUserProfile(this.state).then(
            result => {
                console.log("rest saveUserProfile", result)

            },
            error => console.log("errorrrrrr saveUserProfile")
        );
    }

    render() {
        var user = this.props.userDetail;
        if (this.state.controller) {
            return <main className="main-content" role="main">
                <div className='sweet-loading' style={{ textAlign: 'center', marginTop: 250 }}>
                    <ClipLoader
                        className={override}
                        sizeUnit={"px"}
                        size={250}
                        color={'rgb(54, 215, 183)'}
                        loading={true}
                    />
                </div>
            </main>
        }
        return (
            <main className="main-content p-5" role="main">
                <ToastContainer autoClose={3000} />
                <div className="row mb-4">
                    <div className="col-md-12 card">
                        <div className="row">
                            <div className="col-lg-6 col-md-12" style={{ marginTop: 125, paddingLeft: 45, paddingRight: 45 }}>
                                <div className="row" style={{ marginBottom: 50 }}>
                                    <h2 style={{ display: user.userType === "Broker" ? "none" : "" }}>{user.companyName + " - "}</h2>
                                    <h2>{user.firstName + " " + user.lastName}</h2>
                                    <div style={{ display: user.userType === "Broker" ? "none" : "", paddingTop: "10px", marginLeft: "10px" }}>

                                        {
                                            this.state.Role === 1 ? (<span className="badge badge-info">Accounting</span>) :
                                                (this.state.Role === 2 ? (<span className="badge badge-info">Operation</span>) :
                                                    (this.state.Role === 3 ? (<span className="badge badge-info">Other</span>) : ""))
                                        }
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="form-group col-sm-6">
                                        <div>Name</div>
                                        <input
                                            className="form-control"
                                            type="Text"
                                            id="Name"
                                            name="Name"
                                            value={this.state.Name || ''}
                                            onChange={(val) => this.handleChange(val)} />
                                    </div>
                                    <div className="form-group col-sm-6">
                                        <div>Surname</div>
                                        <input
                                            className="form-control"
                                            type="Text"
                                            id="SurName"
                                            name="SurName"
                                            value={this.state.SurName || ''}
                                            onChange={(val) => this.handleChange(val)} />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="form-group col-sm-6">
                                        <div>Phone Number</div>
                                        <input className="form-control"
                                            type="tel"
                                            id="PhoneNumber"
                                            name="PhoneNumber"
                                            value={this.state.PhoneNumber || ''}
                                            onChange={(val) => this.handleChange(val)} />
                                    </div>
                                    <div className="col-sm-12 col-md-12 col-lg-6">
                                        <div>Email</div>
                                        <input className="form-control" type="Email" id="Email" readOnly value={this.state.Email || ''} />
                                    </div>
                                </div>
                                <div className="row" style={{ display: user.userType === "Broker" ? "none" : "" }}>
                                    <div className="form-group col-sm-6">
                                        <div>Phone Extention</div>
                                        <input className="form-control"
                                            type="tel"
                                            id="PhoneExtention"
                                            name="PhoneExtention"
                                            value={this.state.PhoneExtention || ''}
                                            onChange={(val) => this.handleChange(val)} />
                                    </div>
                                </div>
                                <div className="d-flex justify-content-end" style={{ marginTop: 30, marginBottom: 30 }}>
                                    <button type="submit" className="btn btn-primary btn-gradient waves-effect waves-light btn-lg" onClick={() => this.saveUserProfile()} ><span className="gradient">
                                        <i className="batch-icon  batch-icon-tick   " />
                                        SAVE
                                            </span></button>
                                </div>
                            </div>
                            <div className="col-lg-6 col-md-12" id="profileImageDisplay" style={{ padding: 0 }}>
                                <img src={profileImage} alt="" />
                            </div>
                        </div>
                    </div>
                </div>
            </main>
        );
    }
}


const mapStateToProps = state => {
    return {
        userDetail: state.profileData.userDetail,
        isLoading: state.profileData.isLoading,
        updateResponse: state.profileData.updateResponse

    };

}

const mapDispatchToProps = dispacth => {
    return {
        getUserProfile: () => dispacth(getUserProfile()),
        saveUserProfile: (user) => dispacth(saveUserProfile(user))
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(Profile);


// WEBPACK FOOTER //
// ./src/view/Profile/Profile.js